import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import {constants} from '../../../../shared/common/contants';


@Component({
    selector: 'app-study-library',
    templateUrl: './study-library.component.html',
    styleUrls: ['./study-library.component.scss'],
    standalone: false
})
export class StudyLibraryComponent implements OnInit {

   backgroundColorScreen: string;
    buttonColor: string;
      rowbindingdata;
  
    //selectedTable;
    responserequest;
  
    paginationPageSize;
  
    paginationNumberFormatter;
  
    rowClassRules;
  
    lastpage;
  
    currentpage;
  
    nextpage;
  
    nextpageplusone;
  
    totalpages;
  
    pagesize;
  
    gridApi;
  
    gridColumnApi
  
    columnDefs
  
    defaultColDef
  
    components
  
    options: any;
  
    gridOptions = {
      animateRows: true,
      enableSorting: true,
      enableCellChangeFlash: true,
      context: { componentParent: this },
    };
    value;
    rowData: any[] = [];
  
  
    constructor(private userRoutingModule:UserRoutingModule,
      private retrieveScreenAccess:RetrieveScreenAccess,
      private msg: ErrorMessages,
       private validation: validationmethod,
        private commoService: CommonService, 
        private spinner: NgxUiLoaderService, 
        private snackBar: MatSnackBar, 
        private dialog: MatDialog, 
        private fb: FormBuilder,
        private localStorage: LocalStorageSettingsService,
      private constants: constants,
      private jsignalsService: JsignalService,
      private service: ReportingServiceService,
      private validate: validationmethod,
        private router: Router,
        private route: ActivatedRoute) { }
  
    ngOnInit(): void {
      this.intializeGrid();
      this.loadGridData();
    }

    intializeGrid() {

    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.buttonColor = this.localStorage.getSettings("ColorA");
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
  
        sortable: true,
  
        resizable: true,
  
        filter: true
  
      };
  
      this.columnDefs=[
        // {
        //   headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        //   pinned:'left',
        //   lockPinned:true,
        //   cellRendererParams: {
        //     edit: this.editIcon.bind(this),
        //     delete: this.deleteIcon.bind(this),
        //     access_permission :this.access_permission.bind(this),
        //     schedule: this.scheduleIcon.bind(this),
        //     runAdhoc : this.runIcon.bind(this)
        //   }, width: 260
  
        // },
       
  {
    headerName: 'Study Number',
    headerTooltip: 'Study Number',
    tooltipValueGetter: (params) => 'Study Number : ' + params.value,
    field: 'id',
    filter: 'agSetColumnFilter',
    width: 180,
    cellRenderer: (params) => {
      return `<span class="id-link" style="color:#1976d2;cursor:pointer;text-decoration:underline;">
                ${params.value}
              </span>`;
    },
    onCellClicked: (params) => {
      if (params.data) {
        params.context.componentParent.openStudyDetails(params.data);
      }
    }
  },
        {
          headerName: 'Study Name',
          headerTooltip: 'Study Name',
          tooltipValueGetter: (params) =>
            'Study Name : ' + this.jsignalsService.formatValues(params.value),
          field: 'study_name__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        {
          headerName: 'Masking ',
          headerTooltip: 'Masking ',
          tooltipValueGetter: (params) =>
            'Masking : ' + this.jsignalsService.formatValues(params.value),
          field: 'masking__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        {
          headerName: 'Source organization',
          headerTooltip: 'Source organization',
          tooltipValueGetter: (params) =>
            'Source organization : ' + this.jsignalsService.formatValues(params.value),
          field: 'organization__v_name__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        {
          headerName: 'Study Arm',
          headerTooltip: 'Study Arm',
          tooltipValueGetter: (params) =>
            'Study Arm : ' + this.jsignalsService.formatValues(params.value),
          field: 'study_has_arms__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        {
          headerName: 'Start Date',
          headerTooltip: 'Start Date',
          tooltipValueGetter: (params) =>
            'Start Date : ' + this.jsignalsService.formatValues(params.value) ,
          field: 'start_date__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        {
          headerName: 'LifeCycle State',
          headerTooltip: 'LifeCycle State',
          tooltipValueGetter: (params) =>
            'LifeCycle State : ' + this.jsignalsService.formatValues(params.value) ,
          field: 'lifecycle__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
        // {
        //   headerName: 'Created By',
        //   headerTooltip: 'Created By',
        //   tooltipValueGetter: (params) =>
        //     'Created By : ' + params.value,
        //   field: 'createdBy',
        //   filter: 'agTextColumnFilter',
        //   width: 180,
        // },
        {
          headerName: 'Completion  Date',
          headerTooltip: 'Completion  Date',
          tooltipValueGetter: (params) =>
            'Completion  Date : ' + this.jsignalsService.formatValues(params.value),
          field: 'completion_date__v',
          filter: 'agTextColumnFilter',
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value),
          width: 180,
        },
        {
          headerName: 'Study type',
          headerTooltip: 'Study type',
          tooltipValueGetter: (params) =>
            'Study type: ' + this.jsignalsService.formatValues(params.value),
          field: 'study_type__v_name__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },
                {
          headerName: 'Development phase',
          headerTooltip: 'Development phase',
          tooltipValueGetter: (params) =>
            'Development phase: ' + this.jsignalsService.formatValues(params.value),
          field: 'development_phase__v',
          filter: 'agTextColumnFilter',
          width: 180,
          valueFormatter: (params) => this.jsignalsService.formatValues(params.value)
        },  
        //         {
        //   headerName: 'Study product(s)',
        //   headerTooltip: 'Study product(s)',
        //   tooltipValueGetter: (params) =>
        //     'Study product(s): ' + params.value,
        //   field: 'Studyproducts',
        //   filter: 'agTextColumnFilter',
        //   width: 180,
        // },
        //         {
        //   headerName: 'Study site',
        //   headerTooltip: 'Study site',
        //   tooltipValueGetter: (params) =>
        //     'Study site: ' + params.value,
        //   field: 'Studytype',
        //   filter: 'agTextColumnFilter',
        //   width: 180,
        // },
        // {
        //   headerName: 'Status',
        //   headerTooltip: 'Status',
        //   tooltipValueGetter: (params) => 'Status : ' + params.value,
        //   field: 'status',
        //   filter: 'agTextColumnFilter',
        //   width: 150,
        //   cellStyle: function (params) {
        //     if (params.value == 'Yes') {
        //       return { color: 'green' };
        //     } else {
        //       return { color: 'red' };
        //     }
        //   }
        // },
      ]
      this.paginationPageSize = 10;
  
      this.paginationNumberFormatter = function (params) {
        return params.value.toLocaleString();
      };
  
      this.rowClassRules = {
        'rowBackgroundColor': function (params) {
          var numSickDays = params.node.data.status;
          return numSickDays === "No" || numSickDays === null;
        },
      };
    }

    //excel export function
  onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.rowbindingdata.api.paginationGoToLastPage();
  }
  //pagination code ends

  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  openStudyDetails(rowData) {
  console.log("Clicked Product:", rowData.id);
  // Set rowData information to details Component via shared service 
  this.jsignalsService.setStudy(rowData);

  // Example: navigate to studyDetails  page
   this.router.navigate(['studyDetails',rowData.id], { relativeTo: this.route });


}

// generateDummyStudyRecords(count: number) {
//   const maskingTypes = ["Double Blind", "Single Blind", "Open Label", "Triple Blind"];
//   const organizations = ["Pfizer", "Novartis", "Roche", "AstraZeneca", "Johnson & Johnson", "Merck"];
//   const states = ["In Planning", "Active", "Completed", "On Hold", "Enrollment Complete"];
//   const studyTypes = ["Interventional", "Observational", "Registry"];
//   const phases = ["Phase I", "Phase II", "Phase III", "Phase IV"];
//   const products = ["Dapagliflozin", "Pembrolizumab", "Metformin XR", "Amlodipine", "Semaglutide", "Atorvastatin"];
//   const sites = ["Cleveland Clinic", "Mayo Clinic", "AIIMS Delhi", "Tokyo Medical Center", "Charité Berlin", "UCL Hospital London"];
//   const studyArm = ["Yes" , "No"]

//   const random = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];
//   const randNum = (min: number, max: number) =>
//     Math.floor(Math.random() * (max - min + 1)) + min;

//   const records: any[] = [];

//   for (let i = 1; i <= count; i++) {
//     const startYear = randNum(2020, 2024);
//     const startMonth = randNum(1, 12);
//     const startDay = randNum(1, 28);

//     const endYear = startYear + randNum(0, 2);
//     const endMonth = randNum(1, 12);
//     const endDay = randNum(1, 28);

//     // Veeva-like study number format
//     const sponsorCode = random(["PFZ", "NV", "RCH", "AZ", "JJ", "MRK"]);
//     const studyNumber = `${startYear}-${sponsorCode}-${i.toString().padStart(3, "0")}`;

//     const product = random(products);

//     records.push({
//       studyNumber: studyNumber,
//       StudyName: `Clinical Study of ${product} - ${i}`,
//       Masking: random(maskingTypes),
//       Sourceorganization: random(organizations),

//       StartDate: `${startYear}-${startMonth.toString().padStart(2, "0")}-${startDay
//         .toString()
//         .padStart(2, "0")}`,

//       productState: random(states),
//       createdBy: `vault.user${randNum(1, 50)}@domain.com`,

//       CompletionDate: `${endYear}-${endMonth.toString().padStart(2, "0")}-${endDay
//         .toString()
//         .padStart(2, "0")}`,

//       Studytype: random(studyTypes),
//       Developmentphase: random(phases),
//       Studyproducts: product,
//       Studysite: random(sites),
//       studyArm:random(studyArm)
//     });
//   }

//   return records;
// }

loadGridData() {
   this.spinner.start();
    this.jsignalsService.getLibraryStudy().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.rowData = response;
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching library studies:", error);
        this.snackBar.open("Failed to load library studies", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}




}
